module.exports = "/images/bagy.png?6ce2ad5ec5e2eaac8a7e79faf4a0c2ca";